import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import ArrowIcon from '../../../images/arrow.png';

const TemplateParamsFilters = ({
  getTemplates,
  choosedTemplateTags,
  setChoosedTemplateTags,
  templateParamTags,
  categoryIngredientsTags,
  searchNameTemplate,
  setIsOpened,
  isOpened,
}) => {
  const [choosedTags, setchoosedTags] = useState(choosedTemplateTags);
  const handleCheck = (tagId) => {
    let newChoosedTagsIds = JSON.parse(JSON.stringify(choosedTags));
    if (newChoosedTagsIds.includes(tagId)) {
      newChoosedTagsIds = choosedTags.filter((choosedTagId) => choosedTagId !== tagId);
    } else {
      newChoosedTagsIds.push(tagId);
    }
    setchoosedTags(newChoosedTagsIds);
    setChoosedTemplateTags(newChoosedTagsIds);
  };
  const handleSubmitFilter = () => {
    getTemplates('', searchNameTemplate, choosedTags);
    setIsOpened(!isOpened);
  };

  const [isOpenedDishTags, setIsOpenedPDishTags] = useState(false);
  const openDishTags = () => {
    setIsOpenedPDishTags(!isOpenedDishTags);
  };
  const [isOpenedTemplateTags, setIsOpenedTemplateTags] = useState(false);
  const openTemplateTags = () => {
    setIsOpenedTemplateTags(!isOpenedTemplateTags);
  };
  const resetFilters = () => {
    setChoosedTemplateTags([]);
    setchoosedTags([]);
    getTemplates();
  };

  return (
    <FilterContent>
      <TitleTags onClick={openTemplateTags}>
        Выберите параметры шаблона:
        <TagsImg src={ArrowIcon} alt="arrow" isOpened={isOpenedTemplateTags} />
      </TitleTags>
      <Collapse isOpened={isOpenedTemplateTags}>
        <CheckboxWrapper>
          {!!templateParamTags.length &&
            templateParamTags.map((tag) => (
              <Label key={tag.tag_id}>
                <Input
                  key={tag.tag_id}
                  type="checkbox"
                  value={tag.tag_id}
                  checked={choosedTags.includes(tag.tag_id)}
                  onChange={() => handleCheck(tag.tag_id)}
                />
                {tag.name}
              </Label>
            ))}
        </CheckboxWrapper>
      </Collapse>
      <TitleTags onClick={openDishTags}>
        Выберите какие продукты вы хотите исключить:
        <TagsImg src={ArrowIcon} alt="arrow" isOpened={isOpenedDishTags} />
      </TitleTags>
      <Collapse isOpened={isOpenedDishTags}>
        <CheckboxWrapper>
          {categoryIngredientsTags.map((tag) => (
            <Label key={tag.tag_id}>
              <Input
                key={tag.tag_id}
                type="checkbox"
                value={tag.tag_id}
                checked={choosedTags.includes(tag.tag_id)}
                onChange={() => handleCheck(tag.tag_id)}
              />
              {tag.name}
            </Label>
          ))}
        </CheckboxWrapper>
      </Collapse>
      <ButtonWrapper>
        <FilterButton onClick={handleSubmitFilter}>Фильтровать шаблоны</FilterButton>
        <ResetFiltersButton onClick={resetFilters}>Сбросить все фильтры</ResetFiltersButton>
      </ButtonWrapper>
    </FilterContent>
  );
};

const mapStateToProps = (state) => {
  const { choosedTemplateTags } = state.folders;

  return {
    choosedTemplateTags,
  };
};

export default connect(mapStateToProps)(TemplateParamsFilters);

const FilterContent = styled.div`
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.p`
  height: 40px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  line-height: 40px;
  cursor: pointer;
  background: #157aac;
  color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
`;
const TitleTags = Title.extend`
  width: 100%;
  font-size: 16px;
  margin: 10px 0;
  height: 30px;
`;

const Img = styled.img`
  margin-left: 25px;
  width: 25px;
  height: 25px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(180deg)' : '')};
`;

const TagsImg = Img.extend`
  width: 15px;
  height: 15px;
`;

const CheckboxWrapper = styled.div`
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-self: flex-start;
  @media (max-width: 580px) {
    width: 100%;
    padding-left: 20%;
  }
`;

const Label = styled.label`
  display: flex;
  cursor: pointer;
  align-items: center;
  margin: 3px 0;
  width: 170px;
`;

const Input = styled.input`
  cursor: pointer;
  margin-right: 8px;
`;

const ButtonWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  @media (max-width: 580px) {
    width: 100%;
  }
`;

const FilterButton = styled.button`
  padding: 10px;
  margin: 15px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border: none;
  border-radius: 5px;
  background: #157aac;
  cursor: pointer;
  @media (max-width: 580px) {
    margin: 10px 0;
  }
`;

const ResetFiltersButton = styled.button`
  padding: 10px;
  margin: 15px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  background: #db2828;
  border: none;
  border-radius: 5px;
  @media (max-width: 580px) {
    margin: 10px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/TemplateParamsFilters.jsx